<template>
  <div class="component-container">
    <h3>MSPNG3 Energy and the Electromagnetic Spectrum - Downloads and Resources</h3>
    <div class="back-button-wrapper">
      <button type="button" @click.prevent="cancelButton" class="back-button">Back to Main Dashboard</button>
    </div>
    <div class="presentations">
      <h4>Teacher Presentations</h4>
      <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/activityPresentations%2FAugust%202024%20Updates%2FMSPNG3_Activities_1-4_01082024.zip?alt=media&token=3c1898f1-0233-49a4-9ff3-7478f37dc52e" target="_blank">Activities 1-4 (Zip File) - Updated 1-8-2025</a></li>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/activityPresentations%2FAugust%202024%20Updates%2FMSPNG3_Activities_5-8_01232025.zip?alt=media&token=7fa5a987-f622-40a6-b0bb-19c4cecedb52" target="_blank">Activities 5-8 (Zip File) - Updated 1-23-2025</a></li>
          <li><a href="https://docs.google.com/spreadsheets/d/1RZrQWEcgAu2kxE60cdaDCwpFOj35RFvl_ZiPRYWxAXw/edit?usp=sharing" target="_blank">Teacher Guide Links Spreadsheet</a> - List of all links in the printed Teacher Guide</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1qe8R8GD92WO6dtzWri9pKbKWjAYx2siuRzdE8bcT_6c/edit?gid=1062009112#gid=1062009112">Curriculum Updates Spreadsheet </a> - List with links to updates for your printed Teacher Guide</li>
      </ul>
    </div>
    <div class="presentations">
      <h4>Student Journals</h4>
      <p>Please make a master copy for your classroom and save to your Google drive for your classroom.</p>
      <ul>
        <li><a href="https://docs.google.com/presentation/d/1W9KybZrY4Pb8cgmlaasdFuHpHA6I8cX-1iojoRJkLa8/copy" target="_blank">MSPNG3 Energy and the Electromagnetic Spectrum Student Journal</a></li>
        <li><a href="https://drive.google.com/file/d/1FEGKR7yWiXy2tVwAi6CwgnE1WNHHZkJn/view" target="_blank">MSPNG3 Energy and the Electromagnetic Spectrum Student Journal Answer Key</a></li>
      </ul>

    </div>
    <div class="presentations">
      <h4>Individual Resources</h4>
      <p>The resources below are also linked in the Teacher Led Presentations. We've provided them here for anyone wishing to have access to these individual resources outside of the presentations. Please make master copies and save in your Google drive for your classroom.</p>
        <h4 style="margin-left: 10px;">Charts, Handouts, Card Sets, etc.</h4>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1YET_XUlU7biwqtJ1YSdjp7FRbD_yGZHcmjotNTy9S7Q/copy" target="_blank">What We Think Chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/1dalOocWq17rcddqwQrhUERVUqSsz0J9MPRNbYKcjGRM/copy" target="_blank">Roller Coaster Product Descriptor</a></li>
          <li><a href="https://docs.google.com/presentation/d/1BZtBcbufRXew6he4-Ot9vd0_LHUclpSBaWbr223oIOs/copy" target="_blank">Roller Coaster Photograph Card Set</a></li>
          <li><a href="https://docs.google.com/presentation/d/1Zvqs8gMHc5VxBw30CJKxkR0UyeIoNNG9a-CWWP4KhUk/copy" target="_blank">Anchor Charts</a></li>
          <li><a href="https://docs.google.com/presentation/d/1AJXEo6iqTEr6yQA3NsV7EXGRSaE6EVgu0wbxg2at-4I/copy" target="_blank">Word Sort Cards - Lesson 2A</a></li>
          <li><a href="https://docs.google.com/presentation/d/1P_URnVJvPnN3ZnPmYYAFmP5_jMxb0Szr0AFKKJkT2Dg/copy" target="_blank">The Shape of the Loop (Handout)</a></li>
          <li><a href="https://docs.google.com/spreadsheets/d/1IwY-5pBVraQifA7p5DrTzF2y9UmWHE1MSCUL6CfbTA8/copy" target="_blank">Average Speed Spreadsheet</a></li>
          <li><a href="https://docs.google.com/presentation/d/1Eu58fMmsdngQnATPRdxhkFRD8mNvVu5bKGP4n7gPGsk/copy" target="_blank">Word Sort Cards - Lesson 3B</a></li>
          <li><a href="https://docs.google.com/spreadsheets/d/1ZoCLS4I2GAv8Roy7uuF74Z52IfyhjPJzvWaXmi9WimU/copy" target="_blank">Data Table - Time Needed for Paper Clips to Drop</a></li>
          <li><a href="https://docs.google.com/presentation/d/1aVDJOHk5CGkIBN3SPNWBc31FGPptmm0BlMr643znGBI/copy" target="_blank">Word Sort Cards - Lesson 4C</a></li>
          <li><a href="https://docs.google.com/spreadsheets/d/1yLytpYaomuOMRyDyCexrGhk3yWvZ8DKRt_inADs9Pt0/edit?usp=sharing" target="_blank">Effect of Sunlight (Class Average) Spreadsheet</a></li>
          <li><a href="https://docs.google.com/presentation/d/1vXGFStx2j3EOWCq38L8av1TZ5H398bsOSMR6E5Bn2b0/copy" target="_blank">Chart to Compare Investigations</a></li>
          <li><a href="https://docs.google.com/presentation/d/1GnaEGpOixDbH_7d85HRMjoVNoihAenem31d24Ny9djw/copy" target="_blank">Sun and Clouds Card Set</a></li>
          <li><a href="https://docs.google.com/presentation/d/104CNmXZn5aAEUjd-AziDF2T0z8RHthntl2Q1Ggg76Nw/copy" target="_blank">Word Sort Cards - Lesson 6B</a></li>
          <li><a href="https://docs.google.com/presentation/d/1gkFj0EUT_zp7SJAgL6rRNnbBSaPxf4wvbWgSeIjvfEg/copy" target="_blank">Word Sort Cards - Lesson 6C</a></li>
          <li><a href="https://docs.google.com/presentation/d/1vpQqiZlMcoK3PVafcyZK_kgqnziTjrQFIzFygVfn1vc/copy" target="_blank">Note-Taking Tool for Obtaining Information from Media</a></li>
          <li><a href="https://docs.google.com/presentation/d/1Ffl3xaVoe2peiYq3BXSK7M9aUJFXVFHHHue2K7rlE-Q/copy" target="_blank">Draw the Path of the Light</a></li>
          <li><a href="https://docs.google.com/presentation/d/1ehX3tFsJ7YjNoS5m1jlpXn09tSHn38DH8z2WPlrlSxA/copy" target="_blank">Word Sort Cards - Lesson 6E</a></li>
          <li><a href="https://docs.google.com/presentation/d/1e8J-psxIcfSmSeKnhJBFyS5ImLY_uIel_wvWSSu8iQo/copy" target="_blank">Note-Taking Strategies for Reading in Science</a></li>
          <li><a href="https://docs.google.com/presentation/d/1HeMPMSlQfW7SNhG1cQyTXJm-XeEjtSiPi4jpwuDGDoU/copy" target="_blank">Ultraviolet Light Product Descriptor</a></li>
          <li><a href="https://docs.google.com/presentation/d/13wyJU1vfERRZAiRUzzCpsgbYe2CoZU4VuVSu7nzEPJA/copy" target="_blank">Investigating Ultraviolet Light Pre-Writing Think Sheet</a></li>
          <li><a href="https://docs.google.com/presentation/d/1hD4B-RXcQgooGfeqnuX7KaeL1ReQOLPfhhQcx2Y1NYg/copy" target="_blank">Solar Over Product Descriptor</a></li>
          <!-- <li><a href="" target="_blank"></a></li> -->
        </ul>
    </div>
  </div>
  </template>

  <script>
  import { mapState } from 'vuex'

  export default {
  data() {
    return {}
  },
  computed: {
    ...mapState([ 'dashboardView', 'userProfile' ])
  },
  methods: {
    cancelButton() {
      this.$store.commit('SET_DASHBOARD_VIEW', 'units')
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
  }
  </script>

  <style lang="css" scoped>
  .presentations {
  border: 1px solid grey;
  text-align: left;
  padding: 20px;
  margin: 0 20px 20px 20px;
  }
  ul {
  list-style: none;
  }
  .presentations a {
  margin-left: 40px;
  }
  li {
  margin-left: -40px;
  }
  .back-button-wrapper {
  width: 100%;
  text-align: left;
  margin-bottom: 0;
  }
  .back-button {
  background: white;
  border: none;
  font-weight: 600;
  color: #7b8a1d;
  margin-left: 20px;
  }
  </style>
